import { Pagination as AntdPagination } from 'antd';
import React from 'react';

export const Pagination = ({
    disabled,
    onChange,
    current,
    total,
    pageSize,
    defaultPageSize,
    ...rest
}) => {
    return (
        <AntdPagination
            responsive
            showSizeChanger={false}
            defaultCurrent={1}
            defaultPageSize={50}
            pageSize={pageSize}
            disabled={disabled}
            onChange={onChange}
            current={current}
            total={total}
            showTotal={(total, range) => `${range[1]} из ${total}`}
            {...rest}
        />
    );
};
